import clsx from 'classnames'

import styles from './index.module.css'

interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {}

export function PageHeader ({ children, className, ...rest }: PageHeaderProps): JSX.Element {
  return (
    <div
      className={clsx(styles.wrapper, className)}
      {...rest}
    >
      {children}
    </div>
  )
}
